import { CurrencyPipe, DatePipe } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';

import { LocaleService, WebFrameworkModule } from '@definitiv-packages/angular-dba-library';
import { AngularDocumentsLibraryModule, DOCUMENT_SERVICE_BASE_URI } from '@definitiv-packages/angular-documents-library';
import { COMPLETED_FORM_FIELD_DOCUMENT_DATA_TYPE_ID } from '@definitiv-packages/angular-forms-library';
import { AngularGroupsLibraryModule, GroupPermissionDialog } from '@definitiv-packages/angular-group-library';
import { AngularPermissionLibraryModule, PermissionGroupDialogComponent } from '@definitiv-packages/angular-permissions-library';
import { DocumentDataType } from './types/document-data-type-enum';
import { CreateSafetyPointComponent } from './dialogs/create-safetypoint/create-safetypoint.component';
import { CreateRoofareaComponent } from './dialogs/create-roofarea/create-roofarea.component';
import { CreateSicherungssystemComponent } from './dialogs/create-sicherungssystem/create-sicherungssystem.component';
import { CreateObjektComponent } from './dialogs/create-objekt/create-objekt.component';
import { CreateStandortComponent } from './dialogs/create-standort/create-standort.component';
import { ShowSafetyPointComponent } from './dialogs/show-safetypoint/show-safetypoint.component';


@NgModule({
  declarations: [
    CreateSafetyPointComponent,
    CreateRoofareaComponent,
    CreateSicherungssystemComponent,
    CreateObjektComponent,
    CreateStandortComponent,
    ShowSafetyPointComponent
  ],
  imports: [
    WebFrameworkModule,
    AngularPermissionLibraryModule,
    AngularGroupsLibraryModule,
    AngularDocumentsLibraryModule
  ],
  exports: [
    WebFrameworkModule,
    AngularGroupsLibraryModule,
    AngularPermissionLibraryModule,
    AngularDocumentsLibraryModule,
    CreateSafetyPointComponent,
    CreateRoofareaComponent,
    CreateSicherungssystemComponent,
    CreateObjektComponent,
    CreateStandortComponent
  ],
  providers: [
    DatePipe,
    CurrencyPipe,
    { provide: LOCALE_ID, deps: [LocaleService], useFactory: (LocaleService: { locale: string; }) => LocaleService.locale },
    { provide: GroupPermissionDialog, useValue: PermissionGroupDialogComponent },
    { provide: DOCUMENT_SERVICE_BASE_URI, useValue: '/DocumentDto' },
    { provide: COMPLETED_FORM_FIELD_DOCUMENT_DATA_TYPE_ID, useValue: DocumentDataType.CompletedFormField }
  ]
})
export class LibraryModule { }
